function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4588 7.56094L5.05833 0.180933C4.81586 -0.0607219 4.4233 -0.0603156 4.18124 0.182183C3.93937 0.424651 3.93999 0.817431 4.18249 1.05927L11.1425 8.00003L4.18224 14.9407C3.93977 15.1826 3.93915 15.5752 4.18099 15.8177C4.30234 15.9392 4.4613 16 4.62027 16C4.77883 16 4.93718 15.9396 5.0583 15.8189L12.4588 8.43909C12.5756 8.3229 12.6411 8.16478 12.6411 8.00003C12.6411 7.83528 12.5754 7.67734 12.4588 7.56094Z"
});

function SvgArrowShevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShevron);
export default __webpack_public_path__ + "static/media/arrowShevron.fe180c14.svg";
export { ForwardRef as ReactComponent };